import { System } from '@ecs/System';
import { Lifetime } from '@components/Lifetime';

export class LifetimeSystem extends System {
  update(_deltaTime: number): void {
    const entities = this.getEntitiesWithComponents(Lifetime);

    for (const entity of entities) {
      const lifetime = entity.getComponent(Lifetime)!;
      
      // Update lifetime
      lifetime.current -= 1; // Using frame count instead of deltaTime for now

      // Check if expired
      if (lifetime.current <= 0) {
        this.world.removeEntity(entity);
      }
    }
  }
}